/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircuitBattery = createReactComponent("circuit-battery", "IconCircuitBattery", [
  ["path", { d: "M2 12h4", key: "svg-0" }],
  ["path", { d: "M18 12h4", key: "svg-1" }],
  ["path", { d: "M18 5v14", key: "svg-2" }],
  ["path", { d: "M14 9v6", key: "svg-3" }],
  ["path", { d: "M10 5v14", key: "svg-4" }],
  ["path", { d: "M6 9v6", key: "svg-5" }]
]);

export { IconCircuitBattery as default };
//# sourceMappingURL=IconCircuitBattery.js.map
